import React from 'react';
//style
import styles from 'src/asset/scss/component/title.module.scss'
//comp
import Element from 'src/webapp/views/wrapper/Element';//공통엘리먼트

export default function TitleBar(props) {
	const { title, subtitle } = props;//props

	return (
		<Element tag={`div`} className={styles.titleArea}>
			{title !== undefined && title.length > 0 ? <Element tag={`h1`}>{title}</Element> : null}
			{subtitle !== undefined && subtitle.length > 0 ? <Element tag={`h2`}>{subtitle}</Element> : null}
		</Element>
	);
  }